import type { CSSProperties } from 'react';

import { Particles, Wrapper } from './styles';
export interface MyCustomCSS extends CSSProperties {
	'--i': number;
}

const particles = new Array(2).fill(null);

export const ParticlesPlaceholder = () => (
	<Wrapper>
		{particles.map((_, i) => (
			<Particles key={i} style={{ '--i': i } as MyCustomCSS} />
		))}
	</Wrapper>
);
